import * as Types from '@crimeos-frontend/crime-os/graphql'

import { gql } from '@apollo/client'
export type ChatAiAssistantFragment = {
  __typename: 'ChatAIAssistant'
  aiAssistantType: Types.AiAssistantType
  description?: string | null
  iconUrl?: string | null
  title: string
}

export type AiCopilotAttachmentConfigFragment = {
  __typename: 'AICopilotAttachmentConfig'
  allowedFormats: Array<string>
  maxFileSizeKb: number
  maxFileCount: number
}

export type AiCopilotConfigFragment = {
  __typename: 'AICopilotConfig'
  chatAiAssistants: Array<{
    __typename: 'ChatAIAssistant'
    aiAssistantType: Types.AiAssistantType
    description?: string | null
    iconUrl?: string | null
    title: string
  }>
  attachmentsConfig: {
    __typename: 'AICopilotAttachmentConfig'
    allowedFormats: Array<string>
    maxFileSizeKb: number
    maxFileCount: number
  }
}

export const ChatAiAssistantFragmentDoc = gql`
  fragment ChatAIAssistant on ChatAIAssistant {
    aiAssistantType
    description
    iconUrl
    title
  }
`
export const AiCopilotAttachmentConfigFragmentDoc = gql`
  fragment AICopilotAttachmentConfig on AICopilotAttachmentConfig {
    allowedFormats
    maxFileSizeKb
    maxFileCount
  }
`
export const AiCopilotConfigFragmentDoc = gql`
  fragment AICopilotConfig on AICopilotConfig {
    chatAiAssistants {
      ...ChatAIAssistant
    }
    attachmentsConfig {
      ...AICopilotAttachmentConfig
    }
  }
  ${ChatAiAssistantFragmentDoc}
  ${AiCopilotAttachmentConfigFragmentDoc}
`
